/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    DESIGN_CATEGORIES_title: "Template categories",
    DESIGN_CATEGORIES_label: "category",
    DESIGN_CATEGORIES_pluralLabel: "categories",
    DESIGN_CATEGORIES_description:
        "The sections of the software's template library: web pages, sections, pop-ups, " +
        "e-mails and Studio. Each category belongs to a type and is named in each language; " +
        "French is shown when the user's language is not filled in.",
    DESIGN_CATEGORIES_create: "Add a category",
    DESIGN_CATEGORIES_createTitle: "Add a category",
    DESIGN_CATEGORIES_editTitle: "Edit the category",
    DESIGN_CATEGORIES_save: "Save",
    DESIGN_CATEGORIES_allTypes: "All types",
    DESIGN_CATEGORIES_type_3: "Web pages",
    DESIGN_CATEGORIES_type_6: "Sections",
    DESIGN_CATEGORIES_type_5: "Pop-ups",
    DESIGN_CATEGORIES_type_4: "E-mails",
    DESIGN_CATEGORIES_type_2: "Studio",
    DESIGN_CATEGORIES_columnName: "Name",
    DESIGN_CATEGORIES_columnType: "Type",
    DESIGN_CATEGORIES_columnOrder: "Order",
    DESIGN_CATEGORIES_columnLocales: "Languages",
    DESIGN_CATEGORIES_actionEdit: "Edit",
    DESIGN_CATEGORIES_actionDelete: "Delete",
    DESIGN_CATEGORIES_fieldType: "Template type",
    DESIGN_CATEGORIES_fieldTypePlaceholder: "Choose a type",
    DESIGN_CATEGORIES_fieldOrder: "Order",
    DESIGN_CATEGORIES_orderHelp:
        "Categories are shown from the smallest order to the largest; without an order, last.",
    DESIGN_CATEGORIES_fieldName: "Name ({locale})",
    DESIGN_CATEGORIES_namesHelp:
        "French is required. A language left empty keeps its current name.",
    DESIGN_CATEGORIES_deleteConfirm:
        "Delete the category “{name}” ({type})? This cannot be undone.",
    DESIGN_CATEGORIES_created: "The category has been added.",
    DESIGN_CATEGORIES_updated: "The category has been updated.",
    DESIGN_CATEGORIES_reordered: "The category has been moved.",
    DESIGN_CATEGORIES_dragHint:
        "Drag a row to change the display order of this type's categories.",
    DESIGN_CATEGORIES_pickTypeToReorder:
        "Choose a type to change the display order by dragging the rows.",
    DESIGN_CATEGORIES_deleted: "The category has been deleted.",
    DESIGN_CATEGORIES_emptyTitle: "No category",
    DESIGN_CATEGORIES_emptyDescription: "Add the first one with “Add a category”.",
    DESIGN_CATEGORIES_loadFailedTitle: "List unavailable",
    DESIGN_CATEGORIES_loadFailed: "The category list could not be loaded. Try again later."
};
